'use client'
import * as React from 'react'
import Tab from '@mui/material/Tab'
import { styled } from '@mui/material/styles'
import {TabList} from "@mui/lab"

interface StyledTabsProps {
  children?: React.ReactNode
  value?: number
  centered?: boolean
  onChange: (event: React.SyntheticEvent, newValue: number) => void
}

interface StyledTabProps {
  label: string,
  value: any
}

export const GlassTabList = styled((props: StyledTabsProps) => (
  <TabList
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: '#635ee7',
  },
})

export const GlassTab = styled((props: StyledTabProps) => <Tab disableRipple {...props} />)(
({ theme }) => [
  {
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: '#333',
    '&.Mui-selected': {
      color: '#000',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  },
  theme.applyStyles('dark', {
    color: 'rgba(255, 255, 255, 0.7)',
    '&.Mui-selected': {
      color: '#fff',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  }),
]
)